























































































  import {Component, Prop, Vue} from "vue-property-decorator";
import api from "@/api";

@Component({
  components: {
  }
})
export default class AUser extends Vue {
  @Prop({ default: {} }) private jifenConfig!: any;
  config = {
    jiaoyi: {
      0: '冻结',
      1: '入账',
      2: '兑换'
    },
    type: {
      0: '会员',
      1: '经纪人'
    },
    status: {
      0: '未核销',
      1: '已核销'
    }
  }
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    keyword: '',
    userId: '',
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };


  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0
      };
    }
    api
      .post('J27330', this.search)
      .then(res => {
        this.total = res.total;
        this.tableData = res.list;
      }).finally(() => {
      this.loading = false;
    })
  }

  // 管理订单详情
  detail: any = []
  detailDialog = false
  toDetail(row: any) {
    api
      .post('A23004', {code: row.orderId})
      .then(res =>{
        this.detailDialog = true
        this.detail = [res]
      })
  }

  activated() {
    if(this.$route.query.from == 'broker') {
      this.search.userId = this.$route.query.userId ? this.$route.query.userId : ''
    } else {
      this.search.userId = ''
    }

    // if(this.$route.query.keyword) {
    //   this.search.keyword = this.$route.query.keyword
    // } else {
    //   this.search.keyword = ''
    // }
    this.searchTable();
  }
}
